import React from "react"

import { useTimezone } from "hooks/useTimezone"

import { GetSingleUser } from "services/user/type"

export interface UserPrivacyCardProps {
  user: GetSingleUser
  handleDisable2FA?: () => void
}

export const UserPrivacyCard = ({ user, handleDisable2FA }: UserPrivacyCardProps) => {
  const { formatDateTime } = useTimezone()
  const isExcludedOrNotActivated =
    !user?.activated ||
    (user.exclusion_start &&
      user.exclusion_end &&
      new Date() >= new Date(user.exclusion_start) &&
      new Date() <= new Date(user.exclusion_end))

  return (
    <div className="flex flex-col gap-2 p-6 w-full rounded-[8px] border border-[rgba(0,0,0,0.1)] dark:border-transparent bg-[rgba(212,212,212,0.1)] dark:bg-[rgba(255,255,255,0.04)] text-white backdrop-blur-md">
      <div className="text-black dark:text-white text-lg mb-4">Privacy</div>
      <div className="flex flex-col gap-3">
        <div className="flex justify-between gap-3">
          <div className="text-base text-black dark:text-[rgba(156,163,175,1)] text-nowrap">Account Status</div>
          <div className="text-base text-white text-end">
            {isExcludedOrNotActivated ? (
              <p className="text-[rgba(239,68,68,1)]">Banned</p>
            ) : (
              <p className="text-[rgba(16,185,129,1)]">Not Banned</p>
            )}
          </div>
        </div>
        <div className="flex justify-between gap-3">
          <div className="text-base text-black dark:text-[rgba(156,163,175,1)]">Two-factor Authentication</div>
          <div className="text-base text-black dark:text-white text-end flex items-center">
            {user.use_two_fa ? (
              <p className="text-[rgba(16,185,129,1)] flex flex-row gap-2">
                <p>Enabled</p>
                <button onClick={handleDisable2FA} className="underline text-[rgba(59,130,246,1)]">
                  (Disable)
                </button>
              </p>
            ) : (
              <p className="text-[rgba(245,158,11,1)]">Disabled</p>
            )}
          </div>
        </div>
        <div className="flex justify-between gap-3">
          <div className="text-base text-black dark:text-[rgba(156,163,175,1)]">Email Confirmation</div>
          <div className="text-base text-white text-end">
            {user.email_verified ? (
              <p className="text-[rgba(16,185,129,1)]">Confirmed</p>
            ) : (
              <p className="text-[rgba(245,158,11,1)]">Not Confirmed</p>
            )}
          </div>
        </div>
        <div className="flex justify-between gap-3">
          <div className="text-base text-black dark:text-[rgba(156,163,175,1)]">Phone Confirmation</div>
          <div className="text-base text-white text-end">
            {user.phone_number ? (
              <p className="text-[rgba(16,185,129,1)]">Exists</p>
            ) : (
              <p className="text-[rgba(245,158,11,1)]">No Phone Number</p>
            )}
          </div>
        </div>
        <div className="flex justify-between gap-3">
          <div className="text-base text-black dark:text-[rgba(156,163,175,1)]">Phone Verified</div>
          <div className="text-base text-white text-end">
            {user.phone_number_verified ? (
              <p className="text-[rgba(16,185,129,1)]">Yes</p>
            ) : (
              <p className="text-[rgba(245,158,11,1)]">No</p>
            )}
          </div>
        </div>

        <div className="flex justify-between gap-3">
          <div className="text-base text-black dark:text-[rgba(156,163,175,1)]">Signup IP</div>
          <div className="text-base text-black dark:text-white text-end">
            <div>{user.signup_ip ?? "-"}</div>
            {user.signup_at && <div className="text-xs text-gray-400">{formatDateTime(user.signup_at)}</div>}
          </div>
        </div>

        <div className="flex justify-between gap-3">
          <div className="text-base text-black dark:text-[rgba(156,163,175,1)]">Last Login IP</div>
          <div className="text-base text-black dark:text-white text-end">
            <div>{user.last_login_ip ?? "-"}</div>
            {user.last_login_at && <div className="text-xs text-gray-400">{formatDateTime(user.last_login_at)}</div>}
          </div>
        </div>
      </div>
    </div>
  )
}
